import lykkeClient from "@/api/clients/axios";
import type {
  ProductSearchRequest,
  ProductSearchResponse,
  ProductSearchSuggestionsResponse,
} from "@/types/api/marketplace-product";

export const searchMarketplaceProducts = async (
  body: ProductSearchRequest = {},
  page = 1
): Promise<ProductSearchResponse> => {
  const params: Record<string, number> = {};

  if (page > 1) {
    params.page = page;
  }

  const response = await lykkeClient.post<ProductSearchResponse>(
    "/v2/experiences/product/search",
    body,
    { params }
  );

  return response.data;
};

export const fetchMarketplaceSearchSuggestions = async (
  key = ""
): Promise<ProductSearchSuggestionsResponse> => {
  const response = await lykkeClient.get<ProductSearchSuggestionsResponse>(
    "/v2/experiences/product/search-suggestions",
    {
      params: key.trim() ? { key: key.trim() } : undefined,
    }
  );

  return response.data;
};
